export type AccessTypeEnum =
    'read'
    | 'create'
    | 'update';

export const READ_ACCESS: AccessTypeEnum = 'read';
export const CREATE_ACCESS: AccessTypeEnum = 'create';
export const UPDATE_ACCESS: AccessTypeEnum = 'update';
